import React, { Component } from 'react';
import { toJS } from 'mobx';
import { inject, observer } from 'mobx-react';
import { getPaginationConfig } from '../../../components/pagination';
import { Table } from 'antd';
@inject('reportStore')
@observer
class SearchResult extends Component {
  handlePageChange = (page, pageSize) => {
    const { reportStore } = this.props;
    reportStore.onChangeOrderPageNumAction(page, pageSize);
  }
  getRowClassName = (record, index) => {
    let className = '';
    className = index % 2 === 0 ? 'oddRow' : 'evenRow';
    return className;
  }
  render() {
    const { reportStore, } = this.props
    const { pageNoOrder, pageSizeOrder, itemCountOrder, orderList } = reportStore
    const pagination = getPaginationConfig(pageNoOrder, pageSizeOrder, itemCountOrder, this.handlePageChange);
      return (
        <>
          <Table className='searchResult' dataSource={toJS(orderList)} pagination={pagination} rowClassName={this.getRowClassName} rowKey="id" scroll={{ x: 'max-content',scrollToFirstRowOnChange:true}} bordered >
            <Table.Column title='Sales Organization' dataIndex="salesOrganization" key="salesOrganization"  />
            <Table.Column title='Sales Channel' dataIndex="salesChannel" key="salesChannel"  />
            <Table.Column title='Division' dataIndex="division" key="division"  />
            <Table.Column title='Customer PO Date' dataIndex="customerPoDate" key="customerPoDate"  />
            <Table.Column title='Request Delivery Date' dataIndex="requestDeliveryDate" key="requestDeliveryDate"  />
            <Table.Column title='Distribution Date' dataIndex="distributionDate" key="distributionDate"  />
            <Table.Column title='Arrival Date' dataIndex="rdd" key="rdd"  />
            <Table.Column title='Customer GLN' dataIndex="customerGln" key="customerGln"  />
            <Table.Column title='Goods Receipt GLN' dataIndex="goodsReceiptGln" key="goodsReceiptGln"  />
            <Table.Column title='Vendor Reference Code' dataIndex="vendorReferenceCode" key="vendorReferenceCode"  />
            <Table.Column title='Customer Order Type' dataIndex="customerOrderType" key="customerOrderType"  />
            <Table.Column title='Promotion Mark' dataIndex="promotionMark" key="promotionMark"  />
            <Table.Column title='Customer PO No' dataIndex="customerPoNo" key="customerPoNo"  />
            <Table.Column title='Sales Order' dataIndex="salesOrder" key="salesOrder"  />
            <Table.Column title='Creation Date' dataIndex="creationDate" key="creationDate"  />
            <Table.Column title='PO Instruction' dataIndex="poInstruction" key="poInstruction"  />
            <Table.Column title='Sold To' dataIndex="soldTo" key="soldTo"  />
            <Table.Column title='Sold To Name' dataIndex="soldToName" key="soldToName"  />
            <Table.Column title='Ship To' dataIndex="shipTo" key="shipTo"  />n
            <Table.Column title='Ship To Name' dataIndex="shipToName" key="shipToName"  />
            <Table.Column title='Plant' dataIndex="plant" key="plant"  />
            <Table.Column title='Cust Material Code' dataIndex="custMaterialCode" key="custMaterialCode"  />
            <Table.Column title='Material Code' dataIndex="materialCode" key="materialCode"  />
            <Table.Column title='GTIN' dataIndex="gtin" key="gtin"  />
            <Table.Column title='Material Description' dataIndex="materialDescription" key="materialDescription"  />
            <Table.Column title='Quantity(IT)' dataIndex="quantityIt" key="quantityIt"  />
            <Table.Column title='Quantity' dataIndex="quantity" key="quantity"  />
            <Table.Column title='Confirmation Qty' dataIndex="confirmationQty" key="confirmationQty"  />
            <Table.Column title='Unit' dataIndex="unit" key="unit"  />
            <Table.Column title='Category' dataIndex="materialKind" key="materialKind"  />
            <Table.Column title='Amount' dataIndex="amount" key="amount"  />
          </Table>
        </>
      );
  }
}

export default SearchResult;
